"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_list_store_1 = require("owa-mail-list-store");
var legacy_1 = require("satcheljs/lib/legacy");
// Helper funtion that finds the conversations from all the tables matching
// the folderId and also containing the item id that is passed.
// It then calls the callback to apply the triage action.
// VSO 1458 - we should do the same for pinning and mark junk actions
exports.default = legacy_1.select({
    tableViewConversationRelations: function () { return owa_mail_list_store_1.listViewStore.tableViewConversationRelations; },
    tableViews: function () { return owa_mail_list_store_1.listViewStore.tableViews; },
})(function updateConversationRelations(conversationRowIds, folderId, itemIdsToUpdate, customUpdateFunction, state) {
    conversationRowIds.forEach(function (rowId) {
        state.tableViews.forEach(function (tableView) {
            if (tableView.serverFolderId == folderId) {
                var rowKeys = owa_mail_list_store_1.getRowKeysFromRowIds([rowId], tableView);
                rowKeys.forEach(function (rowKey) {
                    var tableConversationRelation = owa_mail_list_store_1.getTableConversationRelation(rowKey, tableView.id);
                    // The tableConversationRelation can be null, for example,
                    // a read conversation won't be in the unread table view
                    if (!tableConversationRelation) {
                        return;
                    }
                    tableConversationRelation.itemIds.forEach(function (itemId) {
                        // apply the custom update action only if the tableConversationRelation has the specified item.
                        if (itemIdsToUpdate[itemId]) {
                            customUpdateFunction(tableConversationRelation, itemId);
                        }
                    });
                });
            }
        });
    });
});
//# sourceMappingURL=updateConversationRelations.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-list-actions/lib/utils/updateConversationRelations.js
// module id = 5590
// module chunks = 62